import React from 'react';
import { string, object } from 'prop-types';
import useBodega from '../../utils/hooks/bodegaHook';

/**
 * Replaces variables with specific strings
 * @param {String} translation that come from bodega
 * looks like 'Hi, {name}'
 * @param {*} values we provide where we use FormattedTranslation
 * looks like { name: 'Jebediah' }
 * @returns an array of strings that will be consumed by FormattedTranslation
 * looks like ['Hi, ', 'Jebediah', '']
 */
export const replaceValues = (translation, values) => {
  const regex = new RegExp('[{}]', 'g');
  const template = translation.split(regex);

  return template.map(text => {
    if (!values[text]) {
      return text;
    }

    return values[text];
  });
};

/**
 * @param {Object} props
 * {string} translationId Bodega for which we need translations
 * {Object} values object with keys that correspond to translation variables
 * values are strings or JSX elements
 * {string} defaultValue in case we can't find a translation string
 * {object} attributes any attributes you want the rendered component to have
 * @returns {string} formatted string
 */
const FormattedTranslation = props => {
  const { translationId, values, defaultValue, attributes } = props;
  let translation = useBodega(translationId, defaultValue);

  if (values && Object.keys(values).length > 0) {
    translation = replaceValues(translation, values);
  }

  if (typeof translation === 'string') {
    translation = [translation];
  }

  return <span {...attributes}>{translation}</span>;
};

FormattedTranslation.propTypes = {
  translationId: string,
  values: object,
  defaultValue: string,
  attributes: object,
};
export default FormattedTranslation;
